export function dataInRequest(params = {}) {
  return {
    type: '@modulosCliente/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@modulosCliente/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@modulosCliente/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@modulosCliente/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@modulosCliente/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@modulosCliente/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@modulosCliente/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@modulosCliente/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@modulosCliente/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@modulosCliente/RECORD_FILTERING',
    payload: { params },
  };
}
